import { styled } from '@mui/system'
import { TTheme } from '@/core/theme'
import Typography from '@/ui/components/typography'

const ACTIVE_OPACITY = 1
const INACTIVE_OPACITY = 0.5

export const OverviewListItemContainer = styled('div')`
    display: flex;
    align-items: flex-start;
    gap: 12px;
`

export const IconContainer = styled('div')<{
    theme?: TTheme
    isActive?: boolean
    showIconBackground?: boolean
}>`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 42px;
    height: 42px;
    border-radius: 50%;
    background-color: ${({ showIconBackground, theme }) =>
        showIconBackground
            ? theme.colors.semantic.overviewListItemIconBackground
            : 'none'};
    opacity: ${({ isActive }) =>
        isActive ? ACTIVE_OPACITY : INACTIVE_OPACITY};
`

export const ContentContainer = styled('div')`
    display: flex;
    flex-direction: column;
`

export const TitleContainer = styled('div')<{
    isActive?: boolean
}>`
    opacity: ${({ isActive }) =>
        isActive ? ACTIVE_OPACITY : INACTIVE_OPACITY};
`

export const SubtitleTypography = styled(Typography)<{
    isActive?: boolean
}>`
    opacity: ${({ isActive }) =>
        isActive ? ACTIVE_OPACITY : INACTIVE_OPACITY};
`

export const MonitoringStatsCount = styled('span')`
    font-size: var(--font-size-m);
    font-weight: 400;
`

export const SubtitleContainer = styled('div')`
    display: flex;
    align-items: center;
    gap: 8px;
`

export const AlertIcon = styled('span')<{
    theme?: TTheme
}>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    font-size: var(--font-size-xs);
    color: ${({ theme }) => theme?.colors?.semantic?.error };
    cursor: default;
`

export const AlertIconWrapper = styled('span')`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 13px;
    height: 12px;
    cursor: default;
`
